import React, { useEffect } from 'react'

const ColorsSG = () => {
    useEffect(() => {
        // Convert RGB to Hex
        function rgbToHex(rgb) {
            var total = rgb.split(',')
            var r = total[0].substring(4)
            var g = total[1].substring(1)
            var b = total[2].substring(1, total[2].length - 1)
            return (
                '#' +
                checkNumber((r * 1).toString(16)) +
                checkNumber((g * 1).toString(16)) +
                checkNumber((b * 1).toString(16))
            ).toUpperCase()
        }

        // Check Number
        function checkNumber(i) {
            i = i.toString()
            if (i.length == 1) return '0' + i
            else return i
        }

        // Create ColorArray from NodeList
        const colorArray = [...document.querySelectorAll('.accent, .base')]

        colorArray.forEach(function(element) {
            // Get Background Color
            const backgroundColor = window.getComputedStyle(element, null)
            const backgroundValue = backgroundColor.getPropertyValue(
                'background-color',
            )

            element.nextSibling.querySelector('em').textContent = rgbToHex(
                backgroundValue,
            )
        })
    }, [])

    return (
        <div className="row">
            <div className="small-12 columns">
                <h4 className="sg-heading">Accent</h4>
                <ul className="sg-colors">
                    <li>
                        <span className="accent primary-bg"></span>
                        <p>
                            <em></em>
                            <br />
                            <kbd>$primary-color</kbd>
                        </p>
                    </li>
                    <li>
                        <span className="accent secondary-bg"></span>
                        <p>
                            <em></em>
                            <br />
                            <kbd>$secondary-color</kbd>
                        </p>
                    </li>
                    <li>
                        <span className="accent tertiary-bg"></span>
                        <p>
                            <em></em>
                            <br />
                            <kbd>$tertiary-color</kbd>
                        </p>
                    </li>
                    <li>
                        <span className="accent success-bg"></span>
                        <p>
                            <em></em>
                            <br />
                            <kbd>$success-color</kbd>
                        </p>
                    </li>
                    <li>
                        <span className="accent alert-bg"></span>
                        <p>
                            <em></em>
                            <br />
                            <kbd>$alert-color</kbd>
                        </p>
                    </li>
                    <li>
                        <span className="accent warning-bg"></span>
                        <p>
                            <em></em>
                            <br />
                            <kbd>$warning-color</kbd>
                        </p>
                    </li>
                    <li>
                        <span className="accent info-bg"></span>
                        <p>
                            <em></em>
                            <br />
                            <kbd>$info-color</kbd>
                        </p>
                    </li>
                </ul>
                <div className="spacer-small"></div>
                <h4 className="sg-heading">Request colors</h4>
                <ul className="sg-colors">
                    <li>
                        <span className="accent received-bg"></span>
                        <p>
                            <em></em>
                            <br />
                            <kbd>$received</kbd>
                        </p>
                        <br />
                    </li>
                    <li>
                        <span className="accent scheduled-bg"></span>
                        <p>
                            <em></em>
                            <br />
                            <kbd>$scheduled</kbd>
                        </p>
                        <br />
                    </li>
                    <li>
                        <span className="accent repair-in-progress-bg"></span>
                        <p>
                            <em></em>
                            <br />
                            <kbd>$repair-in-progress</kbd>
                        </p>
                    </li>
                    <li>
                        <span className="accent rescheduled-bg"></span>
                        <p>
                            <em></em>
                            <br />
                            <kbd>$rescheduled</kbd>
                        </p>
                        <br />
                    </li>
                    <li>
                        <span className="accent repair-in-progress-bg"></span>
                        <p>
                            <em></em>
                            <br />
                            <kbd>$repair-back-in-progress</kbd>
                        </p>
                    </li>
                    <li>
                        <span className="accent on-hold-bg"></span>
                        <p>
                            <em></em>
                            <br />
                            <kbd>$on-hold</kbd>
                        </p>
                        <br />
                    </li>
                    <li>
                        <span className="accent canceled-bg"></span>
                        <p>
                            <em></em>
                            <br />
                            <kbd>$canceled</kbd>
                        </p>
                        <br />
                    </li>
                    <li>
                        <span className="accent repair-completed-bg"></span>
                        <p>
                            <em></em>
                            <br />
                            <kbd>$repair-completed</kbd>
                        </p>
                        <br />
                    </li>
                </ul>
                <div className="spacer-small"></div>
                <h4 className="sg-heading">Grays</h4>
                <ul className="sg-colors">
                    <li>
                        <span className="base white-bg"></span>
                        <p>
                            <em></em>
                            <br />
                            <kbd>$white</kbd>
                        </p>
                    </li>
                    <li>
                        <span className="base black-bg"></span>
                        <p>
                            <em></em>
                            <br />
                            <kbd>$black</kbd>
                        </p>
                    </li>
                    <li>
                        <span className="base gray-bg"></span>
                        <p>
                            <em></em>
                            <br />
                            <kbd>$gray</kbd>
                        </p>
                    </li>
                    <li>
                        <span className="base light-gray-bg"></span>
                        <p>
                            <em></em>
                            <br />
                            <kbd>$light-gray</kbd>
                        </p>
                    </li>
                    <li>
                        <span className="base medium-gray-bg"></span>
                        <p>
                            <em></em>
                            <br />
                            <kbd>$medium-gray</kbd>
                        </p>
                    </li>
                    <li>
                        <span className="base dark-gray-bg"></span>
                        <p>
                            <em></em>
                            <br />
                            <kbd>$dark-gray</kbd>
                        </p>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default ColorsSG
